import { Box, Container, Grid, Header, Icon, IconProps, SpaceBetween } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import comingSoon from './coming-soon.json';
import pastReleases from './releases.json';

interface ReleaseItem {
    bug?: boolean;
    description: string;
}

export interface ReleaseSection {
    title: string;
    items: ReleaseItem[];
}
const WhatsNewPage = (): JSX.Element => {

    const containerizeReleases = (releases: ReleaseSection[]) => {
        return (
            <SpaceBetween size='l'>
                {
                    releases.map((release: ReleaseSection) => {
                        return (
                            <Container>
                                <Header variant='h3'><i>{release.title}</i></Header>
                                {release.items.map((item: ReleaseItem) => {
                                    const iconName: IconProps.Name = item.bug ? 'bug' : 'microphone';
                                    return (
                                        <p key={item.description}>
                                            <Icon name={iconName}/>
                                            &nbsp;{item.description}
                                        </p>
                                    );
                                })}
                            </Container>
                        );
                    })
                }
            </SpaceBetween>
        );
    };

    const whatsNewSection = (
        <Box>
            <Header variant='h1'>What's new? (features and fixes we've released)</Header>
            {containerizeReleases(pastReleases)}
        </Box>
    );

    const comingSoonSection = (
        <Box>
            <Header variant='h1'>{constants.COMING_SOON + constants.COMING_SOON_2}</Header>
            {containerizeReleases(comingSoon)}
        </Box>
    );

    const gridDefinition = [
        {colspan: {l: 6, m: 6, default: 6} },
        {colspan: {l: 6, m: 6, default: 6} },
    ];

    return (
        <Grid gridDefinition={gridDefinition}>
            {whatsNewSection}
            {comingSoonSection}
        </Grid>
    );
};

export default WhatsNewPage;
